import { captureConsoleIntegration, httpClientIntegration, replayIntegration } from '@sentry/react'
import { parseBoolean } from '@/utils/parse.js'

export const SENTRY_CONFIG = {
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: parseBoolean(import.meta.env.VITE_SENTRY_ENABLED),
  environment: import.meta.env.VITE_APP_ENV,
  integrations: [captureConsoleIntegration(), httpClientIntegration(), replayIntegration()],
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  sendDefaultPii: false,
  tracePropagationTargets: [import.meta.env.VITE_APP_FRONTEND_URL],
  tracesSampleRate: 1.0,
}

export const SENTRY_CLOSE_TIMEOUT = 2000
